// extracted by mini-css-extract-plugin
export var closeButton = "_ho-1";
export var closeX = "_ho-3";
export var container = "_ho-0";
export var image = "_ho-2";